import React, { useEffect } from 'react';
import Loading from 'client/components/Loading';

function CheckLogout() {
    useEffect(() => {
        window.close();
    }, []);
    return <Loading />;
}

export default CheckLogout;
